import { Phone, MessageCircle, CalendarCheck } from "lucide-react";

const WA_LINK =
  "https://wa.me/919688996889?text=Hi%20V-Elite%20Drives%2C%20I%20would%20like%20to%20book%20a%20service%20appointment.";

export default function StickyBar({ onBook }) {
  return (
    <>
      <button
        onClick={onBook}
        data-testid="sticky-action-book"
        className="fixed bottom-[4.6rem] left-1/2 z-50 flex -translate-x-1/2 items-center gap-2 rounded-full bg-gradient-to-br from-gold-light to-gold-deep px-5 py-3 text-[10px] font-bold uppercase tracking-[0.2em] text-ink shadow-[0_10px_36px_rgba(212,175,55,0.35)] transition-transform duration-300 active:scale-95 md:hidden"
      >
        <CalendarCheck size={15} /> Book Service
      </button>

      <div
        data-testid="sticky-action-bar"
        className="fixed inset-x-4 bottom-4 z-50 md:hidden"
      >
        <div className="flex divide-x divide-gold/10 overflow-hidden rounded-full border border-gold/30 bg-graphite/90 shadow-[0_12px_40px_rgba(0,0,0,0.5)] backdrop-blur-xl">
          <a
            href="tel:+919688996889"
            data-testid="sticky-action-call"
            className="flex flex-[1.6] items-center justify-center gap-2.5 py-3.5 text-ivory transition-colors duration-300 active:bg-gold/10"
          >
            <Phone size={16} className="shrink-0 text-gold" />
            <span className="text-[10px] font-bold uppercase tracking-[0.14em]">
              Call 96889 96889
            </span>
          </a>
          <a
            href={WA_LINK}
            target="_blank"
            rel="noreferrer"
            data-testid="sticky-action-whatsapp"
            className="flex flex-1 items-center justify-center gap-2.5 py-3.5 text-ivory transition-colors duration-300 active:bg-gold/10"
          >
            <MessageCircle size={16} className="shrink-0 text-gold" />
            <span className="text-[10px] font-bold uppercase tracking-[0.14em]">
              WhatsApp
            </span>
          </a>
        </div>
      </div>

      <div className="fixed bottom-8 right-8 z-50 hidden flex-col items-end gap-3 md:flex">
        <button
          onClick={onBook}
          data-testid="floating-book-button"
          className="flex items-center gap-2 rounded-full bg-gradient-to-br from-gold-light to-gold-deep px-6 py-3.5 text-[11px] font-bold uppercase tracking-[0.2em] text-ink shadow-[0_10px_40px_rgba(212,175,55,0.3)] transition-transform duration-300 hover:scale-105"
        >
          <CalendarCheck size={15} /> Book Service
        </button>
        <div className="flex gap-3">
          <a
            href="tel:+919688996889"
            data-testid="floating-call-button"
            aria-label="Call V-Elite Drives"
            className="flex h-12 w-12 items-center justify-center rounded-full border border-gold/30 bg-graphite/90 text-gold backdrop-blur-xl transition-colors duration-300 hover:border-gold"
          >
            <Phone size={17} />
          </a>
          <a
            href={WA_LINK}
            target="_blank"
            rel="noreferrer"
            data-testid="floating-whatsapp-button"
            aria-label="WhatsApp V-Elite Drives"
            className="flex h-12 w-12 items-center justify-center rounded-full border border-gold/30 bg-graphite/90 text-gold backdrop-blur-xl transition-colors duration-300 hover:border-gold"
          >
            <MessageCircle size={17} />
          </a>
        </div>
      </div>
    </>
  );
}
